/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgHeartMedical = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11 9h2v2h2v2h-2v2h-2v-2H9v-2h2z" />
        <path d="M15.823 3h.011c1.633 0 3.201.637 4.358 1.774a6.008 6.008 0 0 1 1.806 4.286c0 1.61-.65 3.151-1.805 4.285l-8.194 8.057-8.196-8.057a5.99 5.99 0 0 1 0-8.57C6.043 2.573 9.58 2.42 12 4.316a6.23 6.23 0 0 1 3.548-1.31h.011zm.022 2-.217.005a4.199 4.199 0 0 0-2.75 1.196l-.88.864-.88-.864a4.161 4.161 0 0 0-.747-.583c-1.612-.986-3.767-.791-5.165.583a3.99 3.99 0 0 0 0 5.718l6.792 6.679 6.793-6.68a4.008 4.008 0 0 0 1.207-2.858A4.01 4.01 0 0 0 18.79 6.2 4.217 4.217 0 0 0 15.845 5z" />
      </g>
    </g>
  </Icon>
);
export { SvgHeartMedical as HeartMedical };
